export default "__VITE_ASSET__BwfptUTi__"